export const REMOVE = "REMOVE";
export const CLONE = "CLONE";
export const UPDATE = "UPDATE";

export const remove = (index) => ({ type: REMOVE, index });
export const clone = (index) => ({ type: CLONE, index });
export const update = (_id, cmp, clearUndo = true) => ({ type: UPDATE, component: cmp, _id, clearUndo });
